import { lazy } from "react";

export const ScreenReaderAccess = lazy(
  () => import("../../Features/ScreenReaderAccess")
);
